module.exports = __webpack_public_path__ + "img/ps.12eca035.png";